export default "__VITE_ASSET__0bf4c1c3__"